module.exports = __webpack_public_path__ + "img/toilet-paper-under.96dec1ad.svg";